import React from 'react'
import { localized } from 'decorators'
import Page from './page'

const DeletedListPage = ({ metadata, localize, children, emptyTrash, data }) => {
  return (
    <Page
      title={localize(`${metadata.page}.titleDeleted`)}
      metadata={metadata}
      canCreate={false}
      canGoToTrash={false}
      canEmptyTrash={true}
      emptyTrash={emptyTrash}
      isTrash
      data={data}
      localize={localize}>
      {children}
    </Page>
  )
}

export default localized(DeletedListPage)